import React from 'react';
import { Helmet } from 'react-helmet';
import ResetPassword from 'src/features/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <ResetPassword />
    </React.Fragment>
  );
};

export default ResetPasswordPage;
